module.exports = __webpack_public_path__ + "img/vertical_6_2_8003.f1a6bc4c.png";